{
  "name": "@datatrain/angular-apps",
  "version": "3.13.0",
  "version-businesscockpit": "3.13.3",
  "license": "MIT",
  "scripts": {
    "install-after-compare": "echo 'package.json compare results in npm install required. executing...' && rm package-lock.json && npm cache clean --force && rm -rf node_modules/ && npm install && cp package.json node_modules/package.json",
    "init-git-hooks": "git config --local core.hooksPath .githooks/",
    "update-version": "node ./update-version.js",
    "update-cockpit-version": "node ./update-cockpit-version.js",
    "updateBearerToken": "node tools/updateBearerToken --encodedTokens $bearerTokenToUpdate --fileToUpdate $bearerTokenFile",
    "prepare-cordova-mc": "node ./buildScripts/beforeBuild/prepareCordova_mc.js",
    "prepare-cordova-cp": "node ./buildScripts/beforeBuild/prepareCordova_cp.js",
    "storybook:serve": "npm run storybook:compile:*:serve && npm run storybook:copyAssets:serve && npm run storybook:merge:serve && pnpm nx run ui:storybook",
    "storybook:serve:nocompile": "npm run storybook:copyAssets:serve && pnpm nx run ui:storybook",
    "storybook:copyAssets:serve": "cp -r libs/ui/stories/.assets dist/.assets",
    "storybook:copyAssets:build": "cp -r libs/ui/stories/.assets dist/storybook/ui/.assets",
    "storybook:compile:*:serve": "npm run storybook:compile:c000:serve && npm run storybook:compile:c017:serve && npm run storybook:compile:c030:serve && npm run storybook:compile:c043:serve",
    "storybook:compile:c000:serve": "pnpm nx build mietercockpit -v=c000-web-test-cf && mv apps/mietercockpit/dist/c000-web-test-cf/styles.css dist/styles.c000.css && mv apps/mietercockpit/dist/c000-web-test-cf/*.eot dist && mv apps/mietercockpit/dist/c000-web-test-cf/*.ttf dist && mv apps/mietercockpit/dist/c000-web-test-cf/*.woff dist && mv apps/mietercockpit/dist/c000-web-test-cf/*.woff2 dist",
    "storybook:compile:c017:serve": "pnpm nx build mietercockpit -v=c017-web-test && mv apps/mietercockpit/dist/c017-web-test/styles.css dist/styles.c017.css && mv apps/mietercockpit/dist/c017-web-test/*.eot dist && mv apps/mietercockpit/dist/c017-web-test/*.ttf dist && mv apps/mietercockpit/dist/c017-web-test/*.woff dist && mv apps/mietercockpit/dist/c017-web-test/*.woff2 dist",
    "storybook:compile:c030:serve": "pnpm nx build mietercockpit -v=c030-web-test && mv apps/mietercockpit/dist/c030-web-test/styles.css dist/styles.c030.css && mv apps/mietercockpit/dist/c030-web-test/*.eot dist && mv apps/mietercockpit/dist/c030-web-test/*.ttf dist && mv apps/mietercockpit/dist/c030-web-test/*.woff dist && mv apps/mietercockpit/dist/c030-web-test/*.woff2 dist",
    "storybook:compile:c043:serve": "pnpm nx build mietercockpit -v=c043-web-test && mv apps/mietercockpit/dist/c043-web-test/styles.css dist/styles.c043.css && mv apps/mietercockpit/dist/c043-web-test/*.eot dist && mv apps/mietercockpit/dist/c043-web-test/*.ttf dist && mv apps/mietercockpit/dist/c043-web-test/*.woff dist && mv apps/mietercockpit/dist/c043-web-test/*.woff2 dist",
    "storybook:merge:serve": "npm run storybook:merge:scoping:serve && npm run storybook:merge:sass:serve && npm run storybook:merge:postadjustments:serve",
    "storybook:merge:scoping:serve": "ts-node tools/scope-styles",
    "storybook:merge:sass:serve": "sass dist/styles.scss dist/styles.css",
    "storybook:merge:postadjustments:serve": "ts-node tools/scope-styles-post-sass",
    "storybook:build": "pnpm nx run ui:build-storybook && npm run storybook:compile:*:build:local && npm run storybook:copyAssets:build && npm run storybook:merge:build",
    "storybook:build:local": "pnpm nx run ui:build-storybook && npm run storybook:compile:*:build:local && npm run storybook:copyAssets:build && npm run storybook:merge:build",
    "storybook:compile:*:build:local": "pnpm nx build mietercockpit -v=c000-web-test-cf && pnpm nx build mietercockpit -v=c017-web-test-cf && pnpm nx build mietercockpit -v=c030-web-test && pnpm nx build mietercockpit -v=c043-web-test && pnpm nx build mietercockpit -v=c084-web-test && npm run storybook:compile:*:build",
    "storybook:compile:*:build": "npm run storybook:compile:c000:build && npm run storybook:compile:c017:build && npm run storybook:compile:c043:build && npm run storybook:compile:c030:build",
    "storybook:compile:c000:build": "pnpm nx build mietercockpit -v=c000-web-test-cf && cp apps/mietercockpit/dist/c000-web-test-cf/styles.css dist/storybook/ui/styles.c000.css && cp apps/mietercockpit/dist/c000-web-test-cf/*.eot dist/storybook/ui/ && cp apps/mietercockpit/dist/c000-web-test-cf/*.ttf dist/storybook/ui/ && cp apps/mietercockpit/dist/c000-web-test-cf/*.woff dist/storybook/ui/ && cp apps/mietercockpit/dist/c000-web-test-cf/*.woff2 dist/storybook/ui/",
    "storybook:compile:c017:build": "pnpm nx build mietercockpit -v=c017-web-test-cf && cp apps/mietercockpit/dist/c017-web-test-cf/styles.css dist/storybook/ui/styles.c017.css && cp apps/mietercockpit/dist/c017-web-test-cf/*.eot dist/storybook/ui/ && cp apps/mietercockpit/dist/c017-web-test-cf/*.ttf dist/storybook/ui/ && cp apps/mietercockpit/dist/c017-web-test-cf/*.woff dist/storybook/ui/ && cp apps/mietercockpit/dist/c017-web-test-cf/*.woff2 dist/storybook/ui/",
    "storybook:compile:c030:build": "pnpm nx build mietercockpit -v=c030-web-test && cp apps/mietercockpit/dist/c030-web-test/styles.css dist/storybook/ui/styles.c030.css && cp apps/mietercockpit/dist/c030-web-test/*.eot dist/storybook/ui/ && cp apps/mietercockpit/dist/c030-web-test/*.ttf dist/storybook/ui/ && cp apps/mietercockpit/dist/c030-web-test/*.woff dist/storybook/ui/ && cp apps/mietercockpit/dist/c030-web-test/*.woff2 dist/storybook/ui/",
    "storybook:compile:c043:build": "pnpm nx build mietercockpit -v=c043-web-test && cp apps/mietercockpit/dist/c043-web-test/styles.css dist/storybook/ui/styles.c043.css && cp apps/mietercockpit/dist/c043-web-test/*.eot dist/storybook/ui/ && cp apps/mietercockpit/dist/c043-web-test/*.ttf dist/storybook/ui/ && cp apps/mietercockpit/dist/c043-web-test/*.woff dist/storybook/ui/ && cp apps/mietercockpit/dist/c043-web-test/*.woff2 dist/storybook/ui/",
    "storybook:merge:build": "npm run storybook:merge:scoping:build && npm run storybook:merge:sass:build && npm run storybook:merge:postadjustments:build",
    "storybook:merge:scoping:build": "ts-node tools/scope-styles --build",
    "storybook:merge:sass:build": "sass dist/storybook/ui/styles.scss dist/storybook/ui/styles.css",
    "storybook:merge:postadjustments:build": "ts-node tools/scope-styles-post-sass --build",
    "passenger:build:docs": "npm run build-docs --prefix node_modules/@datatrain/passenger-v3 && npm run server --prefix node_modules/@datatrain/passenger-v3",
    "passenger:build": "npm run compile-css --prefix node_modules/@datatrain/passenger-v3",
    "passenger:watch": "npm run watch --prefix node_modules/@datatrain/passenger-v3",
    "passenger:selectVersion": "ts-node --project tools/tsconfig.tools.json tools/select-passenger-version.ts",
    "passenger:update": "rm -rf node_modules/@datatrain/passenger-v3 && npm install && npm run passenger:build",
    "cleanup:css:all": "ng build mietercockpit -v=c017-web-test && npm run passenger:build && ts-node --project tools/tsconfig.tools.json tools/cleanup-css",
    "cleanup:css": "ts-node --project tools/tsconfig.tools.json tools/cleanup-css",
    "build:enableFormItemDemoToBuildMC": "ts-node --project tools/tsconfig.tools.json tools/enableFormItemDemoToBuildMC",
    "lint-libs": "pnpm nx lint complex-components && pnpm nx lint data && pnpm nx lint loader && pnpm nx lint messages && pnpm nx lint odata && pnpm nx lint plugins && pnpm nx lint ui && pnpm nx lint util && pnpm nx lint web-components",
    "postinstall": "node ./decorate-angular-cli.js && npm run init-git-hooks",
    "serve:c000-neo": "pnpm nx serve mietercockpit -c=c000 --port=4000 --hmr --o",
    "serve:c000-cf": "pnpm nx serve mietercockpit -c=c000-cf --port=4000 --hmr --o",
    "serve:c016-cf": "pnpm nx serve mietercockpit -c=c016-cf --port=4016 --hmr --o",
    "serve:c017-neo": "pnpm nx serve mietercockpit -c=c017 --port=4017 --hmr --o",
    "serve:c017-cf": "pnpm nx serve mietercockpit -c=c017-cf --port=4017 --hmr --o",
    "serve:c030-neo": "pnpm nx serve mietercockpit -c=c030 --port=4030 --hmr --o",
    "serve:c030-cf": "pnpm nx serve mietercockpit -c=c030-cf --port=4030 --hmr --o",
    "serve:c043-neo": "pnpm nx serve mietercockpit -c=c043 --port=4043 --hmr --o",
    "serve:c084-neo": "pnpm nx serve mietercockpit -c=c084 --port=4084 --hmr --o",
    "serve:c090-cf": "pnpm nx serve mietercockpit -c=c090 --port=4090 --hmr --o",
    "serve:c107-cf": "pnpm nx serve mietercockpit -c=c107-cf --port=4107 --hmr --o",
    "serve:mc:neo": "concurrently --names \"C000, C017, C030\" \"npm run serve:c000-neo\" \"npm run serve:c017-neo\" \"npm run serve:c030-neo\"",
    "serve:mc:foundry": "concurrently --names \"C000, C016, C017, C030, C090, C107\" \"npm run serve:c000-cf\" \"npm run serve:c016-cf\" \"npm run serve:c017-cf\" \"npm run serve:c030-cf\" \"npm run serve:c090-cf\" \"npm run serve:c107-cf\"",
    "serve:c000:alt": "pnpm nx serve mietercockpit -c=c000 --port=5000 --hmr --o",
    "serve:c017:alt": "pnpm nx serve mietercockpit -c=c017 --port=5017 --hmr --o",
    "serve:c030:alt": "pnpm nx serve mietercockpit -c=c030 --port=5030 --hmr --o",
    "serve:c043:alt": "pnpm nx serve mietercockpit -c=c043 --port=5043 --hmr --o",
    "serve:mc:alt": "concurrently --names \"C000, C017, C030, C043\" \"npm run serve:c000:alt\" \"npm run serve:c017:alt\" \"npm run serve:c030:alt\" \"npm run serve:c043:alt\"",
    "serve:c000:test": "pnpm nx serve mietercockpit -c=c000-test --port=4000 --hmr --o",
    "serve:c017:test": "pnpm nx serve mietercockpit -c=c017-test --port=4017 --hmr --o",
    "serve:c030:test": "pnpm nx serve mietercockpit -c=c030-test --port=4030 --hmr --o",
    "serve:c043:test": "pnpm nx serve mietercockpit -c=c043-test --port=4043 --hmr --o",
    "serve:mc:test": "concurrently --names \"C000, C017, C030, C043\" \"npm run serve:c000:test\" \"npm run serve:c017:test\" \"npm run serve:c030:test\" \"npm run serve:c043:test\""
  },
  "private": true,
  "dependencies": {
    "@angular-architects/ngrx-toolkit": "^18.1.0",
    "@angular/animations": "18.1.4",
    "@angular/cdk": "18.1.4",
    "@angular/common": "18.1.4",
    "@angular/compiler": "18.1.4",
    "@angular/core": "18.1.4",
    "@angular/forms": "18.1.4",
    "@angular/localize": "18.1.4",
    "@angular/material": "18.1.4",
    "@angular/material-moment-adapter": "18.1.4",
    "@angular/platform-browser": "18.1.4",
    "@angular/platform-browser-dynamic": "18.1.4",
    "@angular/router": "18.1.4",
    "@babel/runtime": "^7.28.6",
    "@datatrain/consentmanagement.c000": "0.1.5",
    "@datatrain/consentmanagement.c016": "0.1.5",
    "@datatrain/consentmanagement.c090": "0.1.5",
    "@datatrain/documents2.c000": "0.0.5",
    "@datatrain/documents2.c016": "0.0.5",
    "@datatrain/module-icons": "3.4.0",
    "@datatrain/module-icons.c000": "4.1.6",
    "@datatrain/module-icons.c016": "4.7.0",
    "@datatrain/module-icons.c017": "4.2.0",
    "@datatrain/module-icons.c107": "4.3.0",
    "@datatrain/notification-overview.c000": "0.4.8",
    "@datatrain/notification-overview.c000.dev.android": "0.4.8",
    "@datatrain/notification-overview.c016": "0.4.8",
    "@datatrain/notification-overview.wcp.c016": "0.4.8",
    "@datatrain/notification-overview.wcp.c016.dev.android": "0.4.8",
    "@datatrain/open-sans": "1.0.3",
    "@datatrain/passenger": "2.15.0",
    "@datatrain/passenger-v3": "3.5.0",
    "@datatrain/queue-microtask": "^1.0.0",
    "@datatrain/ui-icons": "3.4.0",
    "@datatrain/ui-icons.c000": "4.3.5",
    "@datatrain/ui-icons.c016": "4.7.6",
    "@datatrain/ui-icons.c017": "4.3.5",
    "@datatrain/ui-icons.c030": "4.3.5",
    "@datatrain/ui-icons.c107": "4.3.5",
    "@maplibre/ngx-maplibre-gl": "18.2.0",
    "@ngrx/component-store": "18.0.2",
    "@ngrx/signals": "^18.1.0",
    "@ngrx/store": "^18.1.1",
    "@nx/angular": "19.5.7",
    "@storybook/addon-a11y": "8.2.9",
    "@storybook/addons": "7.6.17",
    "@storybook/core-server": "8.2.9",
    "@storybook/theming": "8.2.9",
    "@storybook/web-components": "8.2.9",
    "@swimlane/ngx-charts": "20.5.0",
    "@whitespace/storybook-addon-html": "6.1.1",
    "adm-zip": "^0.5.9",
    "angulartics2": "14.1.0",
    "array-flat-polyfill": "1.0.1",
    "d3-scale": "4.0.2",
    "d3-shape": "3.2.0",
    "dexie": "^4.0.11",
    "events": "^3.3.0",
    "file-saver": "2.0.5",
    "globalthis": "^1.0.4",
    "ics": "3.8.1",
    "js-sha256": "0.9.0",
    "jszip": "^3.10.1",
    "libphonenumber-js": "^1.12.8",
    "lodash": "4.17.23",
    "maplibre-gl": "5.21.0",
    "material-icons": "1.13.11",
    "material-symbols": "0.13.0",
    "moment": "2.29.4",
    "ng-apexcharts": "1.13.0",
    "ngx-autosize": "2.0.4",
    "ngx-mask": "18.0.0",
    "pdfmake": "^0.2.11",
    "polyfill-object.fromentries": "1.0.1",
    "stream": "0.0.2",
    "terser": "4.7.0",
    "timers": "0.1.1",
    "tslib": "^2.0.0",
    "uuid": "8.3.2",
    "web-animations-js": "2.3.2",
    "wicg-inert": "3.1.1",
    "xml2js": "^0.6.2",
    "zone.js": "0.14.8"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "18.1.4",
    "@angular-devkit/core": "18.1.4",
    "@angular-devkit/schematics": "18.1.4",
    "@angular-eslint/eslint-plugin": "18.0.1",
    "@angular-eslint/eslint-plugin-template": "18.0.1",
    "@angular-eslint/template-parser": "18.0.1",
    "@angular/cli": "~18.1.0",
    "@angular/compiler-cli": "18.1.4",
    "@angular/elements": "18.1.4",
    "@angular/language-service": "18.1.4",
    "@etchteam/storybook-addon-css-variables-theme": "3.0.0",
    "@nrwl/js": "19.5.7",
    "@nx/cypress": "19.5.7",
    "@nx/eslint": "19.5.7",
    "@nx/eslint-plugin": "19.5.7",
    "@nx/jest": "19.5.7",
    "@nx/js": "19.5.7",
    "@nx/storybook": "19.5.7",
    "@nx/web": "19.5.7",
    "@nx/workspace": "19.5.7",
    "@schematics/angular": "18.1.4",
    "@storybook/addon-essentials": "8.2.9",
    "@storybook/addon-styling": "1.3.7",
    "@storybook/angular": "8.2.9",
    "@swc-node/register": "~1.9.1",
    "@swc/core": "~1.5.7",
    "@swc/helpers": "~0.5.11",
    "@types/file-saver": "2.0.1",
    "@types/fs-extra": "9.0.11",
    "@types/glob": "8.1.0",
    "@types/he": "1.1.0",
    "@types/jasmine": "5.1.4",
    "@types/jest": "29.4.4",
    "@types/marked": "1.1.0",
    "@types/node": "18.16.9",
    "@types/react": "18.0.3",
    "@types/react-dom": "18.0.0",
    "@types/uuid": "9.0.2",
    "@typescript-eslint/eslint-plugin": "7.16.0",
    "@typescript-eslint/parser": "7.16.0",
    "@typescript-eslint/utils": "^7.16.0",
    "axe-core": "4.1.4",
    "concurrently": "7.6.0",
    "cypress": "^13.0.0",
    "cypress-axe": "1.5.0",
    "cypress-file-upload": "5.0.8",
    "cypress-mochawesome-reporter": "3.5.0",
    "cypress-multi-reporters": "1.6.3",
    "cypress-visual-regression": "3.0.0",
    "eslint": "8.57.0",
    "eslint-config-prettier": "9.0.0",
    "eslint-plugin-cypress": "2.13.4",
    "eslint-plugin-storybook": "0.6.12",
    "fs-extra": "9.0.1",
    "glob": "11.0.0",
    "jasmine": "^5.2.0",
    "jasmine-core": "^5.2.0",
    "jasmine-spec-reporter": "7.0.0",
    "jest": "29.5.0",
    "jest-environment-jsdom": "29.5.0",
    "jest-junit": "13.1.0",
    "jest-preset-angular": "14.1.1",
    "karma": "6.4.2",
    "karma-chrome-launcher": "3.1.0",
    "karma-coverage": "2.0.3",
    "karma-firefox-launcher": "2.1.0",
    "karma-ie-launcher": "1.0.0",
    "karma-jasmine": "5.1.0",
    "karma-sauce-launcher": "4.3.3",
    "lit": "2.6.1",
    "marked": "2.0.3",
    "mocha": "8.3.2",
    "mocha-junit-reporter": "2.0.2",
    "mochawesome": "7.1.3",
    "mochawesome-merge": "4.2.1",
    "mochawesome-report-generator": "6.2.0",
    "moment-timezone": "0.5.40",
    "ngx-build-plus": "18.0.0",
    "nx": "19.5.7",
    "prettier": "3.3.3",
    "react": "17.0.2",
    "react-dom": "17.0.2",
    "replace-in-file": "6.1.0",
    "rimraf": "3.0.2",
    "rxjs": "7.8.1",
    "sass": "1.51.0",
    "storybook": "8.2.9",
    "storybook-addon-themes": "6.1.0",
    "ts-jest": "29.1.0",
    "ts-loader": "8.0.9",
    "ts-node": "10.9.1",
    "ts-node-dev": "1.1.7",
    "tslib": "^2.3.0",
    "tslint": "^6.1.3",
    "tslint-jasmine-rules": "1.6.1",
    "typescript": "5.5.4",
    "webpack": "^5.67.0",
    "yargs": "^16.2.0"
  },
  "resolutions": {},
  "packageManager": "pnpm@10.33.0+sha512.10568bb4a6afb58c9eb3630da90cc9516417abebd3fabbe6739f0ae795728da1491e9db5a544c76ad8eb7570f5c4bb3d6c637b2cb41bfdcdb47fa823c8649319"
}
